export const B2B_ROLE = 'b2b';
export const ADMIN_ROLE = 'admin';
